import React from 'react'
import CookieConsent from 'react-cookie-consent'

export const CookieConsentPrompt = () => {
  return (
    <CookieConsent
      disableButtonStyles
      location="bottom"
      buttonText={global.Translations.get('cookieConsentPromptButtonText')}
      cookieName="CookieConsentPrompt"
      buttonClasses="c-button s-color-blue"
      buttonStyle={{ margin: '1em' }}
    >
      {global.Translations.get('cookieConsentPromptBodyText')}
    </CookieConsent>
  )
}

export default CookieConsentPrompt
